import { UI_LANGS } from "./url-i18n.js";

/** The EDU demo and both portals exist in German and English; every other interface language uses English. */
export const EDU_PAGE_LANGS = Object.freeze(["de", "en"]);

const PATHS = Object.freeze({
  demo: Object.freeze({ de: "/edu-demo", en: "/en/edu-demo" }),
  eduPortal: Object.freeze({ de: "/edu-portal", en: "/en/edu-portal" }),
  portal: Object.freeze({ de: "/portal", en: "/en/portal" }),
});

export const EDU_PAGES = Object.freeze(Object.keys(PATHS));

export function eduPageLang(uiLang) {
  const code = String(uiLang || "").trim().toLowerCase();
  return code === "de" ? "de" : "en";
}

export function getEduPagePath(page, uiLang, suffix = "") {
  const paths = PATHS[page] || PATHS.demo;
  return paths[eduPageLang(uiLang)] + String(suffix || "");
}

/** Language switcher targets: German stays German, everything else lands on English. */
export function eduPathsByUiLang(page) {
  return Object.fromEntries(UI_LANGS.map((code) => [code, getEduPagePath(page, code)]));
}

export function getEduDemoPath(uiLang, suffix = "") {
  return getEduPagePath("demo", uiLang, suffix);
}

export function getEduPortalPath(uiLang, suffix = "") {
  return getEduPagePath("eduPortal", uiLang, suffix);
}

export function getLearnerPortalPath(uiLang, suffix = "") {
  return getEduPagePath("portal", uiLang, suffix);
}

export function allEduPagePaths() {
  return EDU_PAGES.flatMap((page) => EDU_PAGE_LANGS.map((lang) => getEduPagePath(page, lang)));
}
